/**
 * @generated SignedSource<<a09335eac16b4322e0944eb47cd323d0>>
 * @relayHash f69dfce83364b42776e97e2b198f0fbe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e0b1d5f59b43a909539c14bed4b7b0c5610868820fd8e2cbd584e955af371ad0

import type { ConcreteRequest } from 'relay-runtime';
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchConfluenceDocumentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type SearchConfluenceRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchContainerStatus = "ARCHIVED" | "CURRENT" | "%future added value";
export type SearchIssueStatusCategory = "DONE" | "INDETERMINATE" | "NEW" | "OPEN" | "UNDEFINED" | "%future added value";
export type SearchLinkedEntityGranularity = "ALL_MATCHING_MESSAGES" | "DEFAULT" | "FULL_THREAD" | "ONLY_LINKED_ENTITIES" | "%future added value";
export type SearchParticipantType = "COMMENTED" | "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "SHARED" | "VIEWED" | "%future added value";
export type SearchProjectType = "business" | "customer_service" | "product_discovery" | "service_desk" | "software" | "%future added value";
export type SearchSalesforceAttributeFilterOperator = "BETWEEN" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "%future added value";
export type SearchSalesforceAttributeFilterSource = "CUSTOM_PROPERTIES_DATE" | "CUSTOM_PROPERTIES_KEYWORD" | "CUSTOM_PROPERTIES_NUMBER" | "RELATIONSHIPS" | "%future added value";
export type SearchServiceNowAttributeFilterOperator = "BETWEEN" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "%future added value";
export type SearchServiceNowAttributeFilterSource = "ADD_ON_PROPERTIES_DATE" | "KEYWORD" | "RELATIONSHIPS" | "%future added value";
export type SearchSortOrder = "ASC" | "DESC" | "%future added value";
export type SearchThirdPartyRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchCommonFilter = {
  contributorsFilter?: ReadonlyArray<string> | null;
  participants?: SearchParticipants | null;
  range?: SearchCommonRangeFilter | null;
};
export type SearchParticipants = {
  combination: SearchCombinationType;
  items: ReadonlyArray<SearchParticipant>;
};
export type SearchParticipant = {
  combination: SearchCombinationType;
  type: SearchParticipantType;
  users: ReadonlyArray<string>;
};
export type SearchCommonRangeFilter = {
  created?: SearchCommonRangeFilterFields | null;
  lastModified?: SearchCommonRangeFilterFields | null;
};
export type SearchCommonRangeFilterFields = {
  gt?: string | null;
  lt?: string | null;
};
export type SearchConfluenceFilter = {
  ancestorIdsFilter?: ReadonlyArray<string> | null;
  containerARIs?: ReadonlyArray<string> | null;
  containerStatus?: ReadonlyArray<SearchContainerStatus | null> | null;
  contentStatuses?: ReadonlyArray<SearchConfluenceDocumentStatus> | null;
  contributorsFilter?: ReadonlyArray<string> | null;
  creatorsFilter?: ReadonlyArray<string> | null;
  isVerified?: boolean | null;
  labelsFilter?: ReadonlyArray<string> | null;
  mentions?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  pageStatus?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchConfluenceRangeFilter | null> | null;
  spacesFilter?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchConfluenceRangeFilter = {
  field: SearchConfluenceRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchJiraFilter = {
  boardFilter?: SearchBoardFilter | null;
  issueFilter?: SearchJiraIssueFilter | null;
  projectFilter?: SearchJiraProjectFilter | null;
};
export type SearchBoardFilter = {
  negateProjectFilter?: boolean | null;
  projectARI?: string | null;
  userARI?: string | null;
};
export type SearchJiraIssueFilter = {
  assigneeARIs?: ReadonlyArray<string> | null;
  commenterARIs?: ReadonlyArray<string> | null;
  issueLabels?: ReadonlyArray<string> | null;
  issueTypeIDs?: ReadonlyArray<string> | null;
  issueTypes?: ReadonlyArray<string> | null;
  projectARIs?: ReadonlyArray<string> | null;
  reporterARIs?: ReadonlyArray<string> | null;
  statusCategories?: ReadonlyArray<SearchIssueStatusCategory> | null;
  watcherARIs?: ReadonlyArray<string> | null;
};
export type SearchJiraProjectFilter = {
  projectType?: SearchProjectType | null;
  projectTypes?: ReadonlyArray<SearchProjectType> | null;
};
export type SearchAssetsFilter = {
  objectSchemaFilter?: SearchAssetsObjectSchemaFilter | null;
  objectTypeFilter?: SearchAssetsObjectTypeFilter | null;
};
export type SearchAssetsObjectSchemaFilter = {
  schemaARIs?: ReadonlyArray<string> | null;
};
export type SearchAssetsObjectTypeFilter = {
  typeARIs?: ReadonlyArray<string> | null;
};
export type SearchMercuryFilter = {
  ancestorIds?: ReadonlyArray<string> | null;
  focusAreaTypeIds?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
};
export type SearchTalentFilter = {
  employmentTypes?: ReadonlyArray<string> | null;
  focusAreas?: ReadonlyArray<string> | null;
  jobFamilies?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  statuses?: ReadonlyArray<string> | null;
  teams?: ReadonlyArray<string> | null;
};
export type SearchCompassFilter = {
  componentFilter?: SearchCompassComponentFilter | null;
};
export type SearchCompassComponentFilter = {
  componentStates: ReadonlyArray<string>;
};
export type SearchThirdPartyFilter = {
  additionalTexts?: ReadonlyArray<string> | null;
  ancestorAris?: ReadonlyArray<string> | null;
  assignees?: ReadonlyArray<string> | null;
  containerAris?: ReadonlyArray<string> | null;
  containerNames?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  createdBy?: ReadonlyArray<string> | null;
  excludeSubtypes?: ReadonlyArray<string> | null;
  gitFilters?: SearchGitFilters | null;
  gongFilters?: SearchGongFilters | null;
  integrations?: ReadonlyArray<string> | null;
  labels?: ReadonlyArray<string> | null;
  lastUpdatedBy?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchThirdPartyRangeFilter | null> | null;
  salesforceFilters?: SearchSalesforceFilters | null;
  serviceNowFilters?: SearchServiceNowFilters | null;
  subtypes?: ReadonlyArray<string | null> | null;
  teamsFilters?: SearchTeamsFilters | null;
  thirdPartyProducts?: ReadonlyArray<SearchThirdPartyProduct> | null;
  thirdPartyTypes?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchGitFilters = {
  pullRequestStatus?: ReadonlyArray<string> | null;
  repoName?: ReadonlyArray<string> | null;
  reviewer?: ReadonlyArray<string> | null;
};
export type SearchGongFilters = {
  crmAccountName?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyRangeFilter = {
  field: SearchThirdPartyRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchSalesforceFilters = {
  attributeFilters?: ReadonlyArray<SearchSalesforceAttributeFilter> | null;
  campaignStatuses?: ReadonlyArray<string> | null;
  caseStatuses?: ReadonlyArray<string> | null;
  closeDate?: string | null;
  eventTypes?: ReadonlyArray<string> | null;
  isClosed?: boolean | null;
  knowledgeArticlePublishStatuses?: ReadonlyArray<string> | null;
  leadStatuses?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  stage?: ReadonlyArray<string> | null;
  taskStatuses?: ReadonlyArray<string> | null;
  taskTypes?: ReadonlyArray<string> | null;
};
export type SearchSalesforceAttributeFilter = {
  field: string;
  from?: string | null;
  operator: SearchSalesforceAttributeFilterOperator;
  source: SearchSalesforceAttributeFilterSource;
  to?: string | null;
  value?: string | null;
  values?: ReadonlyArray<string> | null;
};
export type SearchServiceNowFilters = {
  attributeFilters?: ReadonlyArray<SearchServiceNowAttributeFilter> | null;
  owners?: ReadonlyArray<string> | null;
};
export type SearchServiceNowAttributeFilter = {
  field: string;
  from?: string | null;
  operator: SearchServiceNowAttributeFilterOperator;
  source: SearchServiceNowAttributeFilterSource;
  to?: string | null;
  value?: string | null;
  values?: ReadonlyArray<string> | null;
};
export type SearchTeamsFilters = {
  attachmentFileTypes?: ReadonlyArray<string> | null;
  hasAttachment?: boolean | null;
  hasLink?: boolean | null;
  messageType?: string | null;
  workspaceName?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyProduct = {
  channels?: ReadonlyArray<string | null> | null;
  connectionIds?: ReadonlyArray<string> | null;
  connectorSources?: ReadonlyArray<string> | null;
  connectorSourcesImpersonationEnabled?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  datasourceId?: string | null;
  entities?: ReadonlyArray<string> | null;
  integrationId?: string | null;
  linkedEntities?: ReadonlyArray<string> | null;
  linkedEntityGranularity?: SearchLinkedEntityGranularity | null;
  product?: string | null;
  providerId?: string | null;
  subtypes?: ReadonlyArray<string> | null;
};
export type SearchSortInput = {
  field: string;
  key?: string | null;
  order: SearchSortOrder;
};
export type SearchExperimentLayer = {
  definitions?: ReadonlyArray<SearchLayerDefinition | null> | null;
  layerId?: string | null;
  name?: string | null;
  shadowId?: string | null;
};
export type SearchLayerDefinition = {
  abTestId?: string | null;
  armId?: string | null;
  connectorSources?: ReadonlyArray<string | null> | null;
  entity?: string | null;
  integrationARI?: string | null;
  layerId?: string | null;
  providerId?: string | null;
  shadowId?: string | null;
  statsigLayerId?: string | null;
  subEntity?: string | null;
};
export type rightPanelAsyncQuery$variables = {
  assetsFilters?: SearchAssetsFilter | null;
  cloudIdARI: string;
  commonFilters?: SearchCommonFilter | null;
  compassFilters?: SearchCompassFilter | null;
  confluenceFilters?: SearchConfluenceFilter | null;
  disableQueryReplacement?: boolean | null;
  entities: ReadonlyArray<string>;
  expectResult?: boolean | null;
  experience: string;
  experimentId?: string | null;
  experimentLayers?: ReadonlyArray<SearchExperimentLayer | null> | null;
  jiraFilters?: SearchJiraFilter | null;
  limit: number;
  mercuryFilters?: SearchMercuryFilter | null;
  query: string;
  queryVersion?: number | null;
  searchSessionId?: string | null;
  sessionId?: string | null;
  shadowExperimentId?: string | null;
  sort?: ReadonlyArray<SearchSortInput | null> | null;
  sourceProduct?: string | null;
  talentFilters?: SearchTalentFilter | null;
  thirdPartyFilters?: SearchThirdPartyFilter | null;
  useCaseId?: string | null;
};
export type rightPanelAsyncQuery$data = {
  readonly search: {
    readonly results: {
      readonly isCachedResult: boolean | null;
      readonly totalCounts: ReadonlyArray<{
        readonly count: number;
        readonly product: string;
      }>;
    } | null;
  } | null;
};
export type rightPanelAsyncQuery = {
  response: rightPanelAsyncQuery$data;
  variables: rightPanelAsyncQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetsFilters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdARI"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commonFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compassFilters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confluenceFilters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disableQueryReplacement"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entities"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expectResult"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentLayers"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraFilters"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mercuryFilters"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryVersion"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchSessionId"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shadowExperimentId"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceProduct"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "talentFilters"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "thirdPartyFilters"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useCaseId"
},
v24 = [
  {
    "concreteType": "SearchQueryAPI",
    "kind": "LinkedField",
    "name": "search",
    "plural": false,
    "selections": [
      {
        "alias": "results",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "queryVersion",
                "variableName": "queryVersion"
              },
              {
                "kind": "Variable",
                "name": "searchSessionId",
                "variableName": "searchSessionId"
              },
              {
                "kind": "Variable",
                "name": "sessionId",
                "variableName": "sessionId"
              },
              {
                "kind": "Variable",
                "name": "sourceProduct",
                "variableName": "sourceProduct"
              }
            ],
            "kind": "ObjectValue",
            "name": "analytics"
          },
          {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
          },
          {
            "kind": "Variable",
            "name": "expectResult",
            "variableName": "expectResult"
          },
          {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "experimentId",
                "variableName": "experimentId"
              },
              {
                "kind": "Variable",
                "name": "experimentLayers",
                "variableName": "experimentLayers"
              },
              {
                "kind": "Variable",
                "name": "shadowExperimentId",
                "variableName": "shadowExperimentId"
              }
            ],
            "kind": "ObjectValue",
            "name": "experimentContext"
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "assetsFilters",
                "variableName": "assetsFilters"
              },
              {
                "kind": "Variable",
                "name": "commonFilters",
                "variableName": "commonFilters"
              },
              {
                "kind": "Variable",
                "name": "compassFilters",
                "variableName": "compassFilters"
              },
              {
                "kind": "Variable",
                "name": "confluenceFilters",
                "variableName": "confluenceFilters"
              },
              {
                "kind": "Variable",
                "name": "entities",
                "variableName": "entities"
              },
              {
                "kind": "Variable",
                "name": "jiraFilters",
                "variableName": "jiraFilters"
              },
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "locations.0",
                    "variableName": "cloudIdARI"
                  }
                ],
                "kind": "ListValue",
                "name": "locations"
              },
              {
                "kind": "Variable",
                "name": "mercuryFilters",
                "variableName": "mercuryFilters"
              },
              {
                "kind": "Variable",
                "name": "talentFilters",
                "variableName": "talentFilters"
              },
              {
                "kind": "Variable",
                "name": "thirdPartyFilters",
                "variableName": "thirdPartyFilters"
              }
            ],
            "kind": "ObjectValue",
            "name": "filters"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
          },
          {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
          },
          {
            "kind": "Variable",
            "name": "useCaseId",
            "variableName": "useCaseId"
          }
        ],
        "concreteType": "SearchItemConnection",
        "kind": "LinkedField",
        "name": "asyncSearch",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isCachedResult"
          },
          {
            "concreteType": "SearchProductCount",
            "kind": "LinkedField",
            "name": "totalCounts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "product"
              },
              {
                "kind": "ScalarField",
                "name": "count"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/)
    ],
    "kind": "Fragment",
    "name": "rightPanelAsyncQuery",
    "selections": (v24/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v14/*: any*/),
      (v1/*: any*/),
      (v12/*: any*/),
      (v6/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v11/*: any*/),
      (v0/*: any*/),
      (v13/*: any*/),
      (v21/*: any*/),
      (v3/*: any*/),
      (v22/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v9/*: any*/),
      (v18/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v23/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "rightPanelAsyncQuery",
    "selections": (v24/*: any*/)
  },
  "params": {
    "id": "e0b1d5f59b43a909539c14bed4b7b0c5610868820fd8e2cbd584e955af371ad0",
    "metadata": {},
    "name": "rightPanelAsyncQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f522660a2c82ee144f847002743006c8";

export default node;
